(() => {
  const script = document.currentScript;
  const features = [
    {selector: 'quick-view-button, quick-view', js: script.dataset.quickJs, css: script.dataset.quickCss},
    {selector: 'color-swatch, color-swatch-radios', js: script.dataset.swatchJs, css: script.dataset.swatchCss}
  ].filter(feature => feature.js);
  function load(feature) {
    if (feature.pending) return feature.pending;
    const css = document.createElement('link');
    css.rel = 'stylesheet'; css.href = feature.css;
    document.head.append(css);
    feature.pending = new Promise((resolve, reject) => {
      const js = document.createElement('script');
      js.src = feature.js;
      js.onload = () => { feature.ready = true; if (features.every(item => item.ready)) observer.disconnect(); resolve(); };
      js.onerror = () => { js.remove(); css.remove(); feature.pending = null; reject(new Error('Catalog feature unavailable')); };
      document.head.append(js);
    });
    return feature.pending;
  }
  function scan(root = document) {
    features.forEach(feature => {
      if (!feature.pending && (root.matches?.(feature.selector) || root.querySelector?.(feature.selector))) load(feature).catch(() => {});
    });
    if (features.every(feature => feature.ready)) observer.disconnect();
  }
  const observer = new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1) scan(node); }));
  });
  observer.observe(document.body, {childList: true, subtree: true});
  document.addEventListener('click', event => {
    const feature = features.find(item => !item.ready && event.target.closest(item.selector));
    if (!feature) return;
    const target = event.target.closest('button, a, input, label') || event.target;
    event.preventDefault(); event.stopImmediatePropagation();
    load(feature).then(() => { if (target.isConnected) target.click(); }).catch(() => {
      const link = target.closest('.card-wrapper')?.querySelector('a[href*="/products/"]');
      if (link) window.location.assign(link.href);
    });
  }, true);
  scan();
})();
